// extracted by mini-css-extract-plugin
export default {"loader":"LoadAnimation_loader__oaDIP","l15":"LoadAnimation_l15__HqlQi"};